import {OptionType} from 'shared/model/types';

import {absoluteIri} from 'shared/api/iriHelper';

import ITariff from '../model/ITariff';
import {ITariffVariant} from '../model/ITariffVariant';


export const getTariffOption = (item: ITariff): OptionType => {
    return {
        value: absoluteIri('tariffs', item?.id),
        label: item.name,
    };
};

export const getTariffVariantOption = (item: ITariffVariant): OptionType => {
    return {
        value: absoluteIri('tariff-variants', item?.id),
        label: String(item.period),
    };
};